<template>
  <div>
    <!-- <ShowCi
      :show_dialog="show_dialog"
      :selected_ci="selected_ci"
      :closeDialog="closeShowDialog"
      :editor_open="editor_open"
      :sended="sended"
    /> -->
    <v-data-table
      v-if="all_ics"
      :headers="headers"
      :items="all_ics"
      item-key="id"
      class="elevation-1"
      item-class="teste"
      :search="search"
    >
      <template v-slot:top>
        <v-row>
          <v-col cols="12" md="4" lg="4">
            <v-text-field
              v-model="search"
              label="Pesquisar"
              class="mx-4"
              outlined
              dense
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="4" lg="4">
            <v-select
              v-model="workstation"
              :items="workstations"
              item-value="id"
              item-text="workstation"
              label="Vínculo"
              outlined
              dense
              class="mx-4"
            ></v-select>
          </v-col>
          <v-col cols="12" md="4" lg="4">
            <v-select
              v-model="department"
              :items="departments"
              item-value="id"
              item-text="department"
              label="Departamentos"
              outlined
              dense
              class="mx-4"
            ></v-select>
          </v-col>
        </v-row>
      </template>
      <template v-slot:item="{ item }">
        <tr :class="{ visualised: item.visualised }" :key="item.id">
          <td class="overflow-x-hidden">
            {{ item.created_by }}
          </td>
          <td
            style="max-width: 50vw; text-overflow: ellipsis; overflow: hidden; white-space: nowrap"
            class="overflow-x-hidden"
          >
            <span
              v-html="item.message"
              style="max-height: 48px"
              class="overflow-y-hidden d-flex"
            ></span>
          </td>
          <td class="overflow-x-hidden">
            {{ formatDate(item.created_at) }}
          </td>
          <td class="overflow-x-hidden">
            <v-btn icon large @click="viewPdf(item)"
              ><v-icon large color="red">mdi-file-pdf</v-icon></v-btn
            >
          </td>
        </tr>
      </template>
    </v-data-table>
  </div>
</template>

<script>
// import ShowCi from './ShowCi'
import { formatDateToShow } from '@/global/functions.js'
import { mapActions, mapState } from 'vuex'
export default {
  name: 'AllCIList',
  //   components: { ShowCi },
  props: [],
  data: function () {
    return {
      headers: [
        { text: 'De', value: 'created_by' },
        { text: 'Menssagem', value: 'message' },
        { text: 'Data', value: 'created_at' },
        { text: 'Ações' },
      ],
      selected_ci: '',
      show_dialog: false,
      new_dialog: false,
      editor_open: false,
      search: '',
      department: '',
      workstation: '',
      filtered_cis: [],
    }
  },
  computed: {
    ...mapState('utils', ['departments', 'workstations']),
    ...mapState('ci', ['all_ics']),
  },
  mounted: () => {
    this.filtered_cis = this.all_ics
  },
  methods: {
    ...mapActions('ci', ['ActionVisualizeIC', 'ActionViewPDF']),
    async viewPdf(item) {
      try {
        const pdf = await this.ActionViewPDF(item.id)
        var blob = new Blob([pdf], { type: 'application/pdf;base64' })
        var blobURL = URL.createObjectURL(blob)
        window.open(blobURL)
      } catch (error) {
        console.log(error)
      }
    },
    formatDate(date) {
      return formatDateToShow(date)
    },
    closeShowDialog() {
      this.show_dialog = false
    },
    showCi(ci) {
      this.show_dialog = true
      this.selected_ci = ci
      if (!ci.visualised) this.ActionVisualizeIC(ci.id)
    },
    itemRowBackground(item) {
      return item.visualised ? 'row-visualised' : null
    },
  },
}
</script>

<style>
.visualised {
  background-color: #ccc;
}
</style>
